import React from "react";
import AccreditationButton from "../../../components/AccreditationButton/AccreditationButton";

const SecondStep = ({
  t,
  code,
  errors,
  handleCodeChange,
  handlePasteCode,
  inputsRef,
  handleLogin,
  submitButtonRef,
  otpChannel,
}) => {
  const otpNoticeKey =
    otpChannel === "email" ? "LOGIN_OTP_SENT_EMAIL" : "LOGIN_OTP_SENT_SMS";

  const handleChange = (index, rawValue) => {
    const digitsOnly = rawValue.replace(/\D/g, "");
    // A pasted/autofilled code lands in one field before maxLength trims it
    // to 1 char (autofill can bypass maxLength entirely) — route anything
    // longer than a single digit through the multi-field paste handler.
    if (digitsOnly.length > 1) {
      handlePasteCode(digitsOnly);
      return;
    }
    handleCodeChange(index, rawValue);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    handlePasteCode(e.clipboardData.getData("text"));
  };

  return (
    <div className="flex-direction-column gap-48 justify-between">
      <div className="flex-direction-column gap-18">
        <h2 className="font-16 inria-sans-300 login-description">
          {t("ENTER_CODE")}
        </h2>
        {otpChannel && (
          <p className="font-14 inria-sans-300 login-otp-notice">
            {t(otpNoticeKey)}
          </p>
        )}
        <div className="flex-direction-row gap-12 justify-center">
          {code.map((digit, index) => (
            <input
              key={index}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete={index === 0 ? "one-time-code" : "off"}
              value={digit}
              maxLength="1"
              className={`login-code-input ${
                errors.code && digit === "" ? "error" : ""
              }`}
              onChange={(e) => handleChange(index, e.target.value)}
              onPaste={handlePaste}
              onKeyDown={(e) => {
                if (e.key === "ArrowLeft" && index > 0) {
                  const prevInput = inputsRef.current[index - 1];
                  prevInput?.focus();
                  setTimeout(() => {
                    prevInput?.setSelectionRange(1, 1);
                  }, 0);
                } else if (e.key === "ArrowRight" && index < 5) {
                  const nextInput = inputsRef.current[index + 1];
                  nextInput?.focus();
                  setTimeout(() => {
                    nextInput?.setSelectionRange(1, 1);
                  }, 0);
                } else if (e.key === "Backspace") {
                  if (digit !== "") {
                    // samo obriši trenutni
                    handleCodeChange(index, "");
                  } else if (index > 0) {
                    // prebaci na prethodni i obriši njega
                    const prevInput = inputsRef.current[index - 1];
                    handleCodeChange(index - 1, "");
                    prevInput?.focus();
                    setTimeout(() => {
                      prevInput?.setSelectionRange(1, 1);
                    }, 0);
                  }
                  e.preventDefault();
                }
              }}
              onFocus={(e) => {
                e.target.setSelectionRange(1, 1); // ili e.target.select();
              }}
              ref={(el) => (inputsRef.current[index] = el)}
            />
          ))}
        </div>
      </div>
      <AccreditationButton
        type="save"
        title="Login"
        className="login-btn"
        onClick={handleLogin}
        ref={submitButtonRef}
      />
    </div>
  );
};

export default SecondStep;
